import { render, staticRenderFns } from "./NoticesPublic.vue?vue&type=template&id=6053451e&"
import script from "./NoticesPublic.vue?vue&type=script&lang=js&"
export * from "./NoticesPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports